/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RespondToInactivityNudgeRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {RespondToInactivityNudgeResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const respondToInactivityNudge = (request: RespondToInactivityNudgeRequest, options?: CashRequestOptions) => post<RespondToInactivityNudgeRequest, RespondToInactivityNudgeResponse>("/2.0/cash/respond-to-inactivity-nudge", request, {...options, rejectOnError: true })